import { render, staticRenderFns } from "./StartupsTable.vue?vue&type=template&id=9a49a438&scoped=true&"
import script from "./StartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a49a438",
  null
  
)

export default component.exports